export function getBooleanValue(value?: string | boolean | null) {
  if (typeof value === 'string') return value.toLowerCase() === 'true';

  return !!value;
}
